import React from 'react';
import Create from './pages/Create';
import Edit from './pages/Edit';
import Index from './pages/Index';
import { AppRouteProps } from '~/routes';

export default function DispatchGroupRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/dispatch/group', component: Index, isProtected: true, permissions: ['dispatch_group_index']},
    {path: '/dispatch/group/create', component: Create, isProtected: true, permissions: ['dispatch_group_create']},
    {path: '/dispatch/group/edit/:id', component: Edit, isProtected: true, permissions: ['dispatch_group_edit']},

  ];

  return routes;
}
